export default __webpack_public_path__ + "static/media/CF-Logo-16x9-wide-1024x439-removebg-preview.611448bc.png";